// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import DataVaxiomOtherProfessionalsEdit from './view'

export default function DataVaxiomOtherProfessionalsEditFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/DataVaxiomOtherProfessionalsEdit">
      <DataVaxiomOtherProfessionalsEdit {...props}>
        {children}
      </DataVaxiomOtherProfessionalsEdit>
    </Flow>
  )
}
